<template>
    <div class="lb-card-media-content">
        <div
            v-if="image"
            class="columns is-gapless is-marginless is-multiline is-centered"
        >
            <div class="column" style="position: relative">
                <figure class="image is-16by9">
                    <img
                        :src="image | mediaSource"
                        width="100"
                        style="object-fit: scale-down"
                    />
                </figure>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeImage()"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </div>
        </div>

        <vue-plyr v-if="video" :key="videoId">
            <div class="plyr__video-embed">
                <iframe
                    :src="`https://www.youtube.com/embed/${videoId}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                />
            </div>
        </vue-plyr>

        <div v-if="embed" class="is-relative">
            <div class="is-clipped" v-html="embed"></div>
            <button
                v-if="showControls"
                style="margin-top: 0.5rem"
                class="lb-delete-media"
                @click.stop="removeEmbed"
            >
                <span class="icon is-small">
                    <i class="fas fa-trash" />
                </span>
            </button>
        </div>

        <div v-if="url && !urlInfo" class="has-text-centered lb-media-link">
            <p class="is-relative">
                <a
                    :href="url"
                    target="_blank"
                    class="button is-link is-fullwidth"
                >
                    <span class="icon">
                        <i class="fas fa-link" />
                    </span>
                    <span>{{ $t('Object.url_more_info') }}</span>
                </a>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeURL"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </p>
        </div>
        <a v-if="urlInfo" :href="urlInfo.link" class="box media my-2">
            <figure v-if="urlInfo.image" class="media-left">
                <p class="image is-64x64">
                    <img :src="urlInfo.image.url" />
                </p>
            </figure>
            <div class="media-content">
                <div class="content">
                    <p>
                        <strong>{{ urlInfo.title }}</strong>
                        <br />
                        <small>{{ urlInfo.source }}</small>
                        <br />
                        {{ urlInfo.description }}
                    </p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import { getURLMetadata } from '@/services/API';

import _ from 'underscore';
export default {
    components: {},
    filters: {
        mediaSource(media) {
            if (typeof media === 'string') return media;
            if (typeof media === 'object') {
                if (_.isArray(media) && media.length) return media[0].url;
                else {
                    return media.url;
                    //return `https://img.labygram.com/upload/c_1/${media.url}`;
                }
            }
        },
    },
    props: {
        image: { type: Object, default: undefined },
        url: { type: String, default: undefined },
        video: { type: String, default: undefined },
        embed: { type: String, default: undefined },
        showControls: { type: Boolean, default: false },
    },
    data() {
        return {
            videoInfo: { thumbnails: { high: {} } },
            urlInfo: undefined,
        };
    },
    computed: {
        videoId() {
            return this.$youtube.getIdFromUrl(this.video);
        },
        videoThumbnail() {
            return this.videoInfo.thumbnails.high;
        },
    },
    watch: {
        url: {
            handler() {
                this.loadURLPreview();
            },
            immediate: true,
        },
    },
    methods: {
        removeImage() {
            this.$emit('update:image', undefined);
        },
        removeURL() {
            this.$emit('update:url', undefined);
        },
        removeEmbed() {
            this.$emit('update:embed', undefined);
        },
        async loadURLPreview() {
            if (!this.url) {
                return;
            }
            const metadataRequest = await getURLMetadata(this.url);
            if (metadataRequest.data.success) {
                this.urlInfo = metadataRequest.data.meta;
            }
        },
    },
};
</script>

<style lang="sass" scoped>
.lb-card-media-content
  display: flex
  flex-direction: column
  justify-content: flex-start

.lb-card-media-content > * + *
  padding-top: 0.5rem

.lb-card-media-content:last-child
  padding: 0

.overflow
  text-overflow: ellipsis
  white-space: nowrap
  overflow: hidden
</style>

<style lang="sass" scoped>
@import "src/assets/sass/slider"
::v-deep .agile
  &__nav-button
    width: 3.5rem
  .icon
    &:hover
      background-color: rgba(#000, .5)
      opacity: 1
      &:hover
        background: transparent
</style>
